import { getUrl, usePlatformGet } from '@reapitform/hooks'
import { IDocumentActivityLog } from '../types'
import { useMemo } from 'react'

export const useDocumentActivityLog = (documentId: string) => {
  const path: string = `/api/User/Document/${documentId}/Activities`
  const [result, loading, errorString] = usePlatformGet<IDocumentActivityLog>({
    path,
    retry: false,
  })

  const queryKey = useMemo(getUrl(path), [path])

  return { data: result, loading, errorString, queryKey }
}
